module.exports = __webpack_public_path__ + "static/img/3.4dca486.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Empresarial-Fraude-Empleados/3.png
// module id = ulHB
// module chunks = 0